import React, { Component } from 'react'
import { BrowserRouter, Route } from 'react-router-dom';
import DataTable from '../../../components/DataTable/DataTable';
import FrontendHotelForm from './FrontendHotelForm';
import TitleHeader from '../../../components/TitleHeader/TitleHeader'

class FrontendHotel extends Component {
    render() {
        const columns = [
            { label: 'ชื่อ', align: 'left', name: 'name', search_type: 'string' },
            { label: 'เบอร์โทร', align: 'left', name: 'telephone', search_type: 'string' },
        ];

        const api_url = '/master/hotel';

        return (
            <BrowserRouter>
                <div>
                    <TitleHeader program_name='ที่พัก' program_type='Frontend'></TitleHeader>
                    
                    <Route exact path={`${this.props.match.path}/`} component={() => (<DataTable columns={columns} allow_active={true} url={api_url}></DataTable>)} />
                    
                    <Route path={`${this.props.match.path}/create`} component={props => (<FrontendHotelForm {...props} url={api_url}></FrontendHotelForm>)} />
                    <Route path={`${this.props.match.path}/:id/edit`} component={props => (<FrontendHotelForm {...props} url={api_url}></FrontendHotelForm>)} />
                </div>
            </BrowserRouter>
        )
    }
}

export default FrontendHotel
